<div class="left">
  <i [style.background-color]="categoryColor"></i>
  <p>{{categoryName}}</p>
</div>
<div class="right" *ngIf="categoryPriceStart">
  <p><span>{{"à partir de" | customTranslation: "startingAt"}}</span><strong>{{categoryPriceStart | currency:currency.isoCode}}</strong></p>
</div>
